import styled from "styled-components";

import { Box, BorderlessInput } from "src/components";

import { Icons } from "../../../Icons";

export const Container = styled(Box)`
  width: 100%;
  margin-bottom: 24px;
`;

export const Input = styled(BorderlessInput)`
  font-size: 15px;
  border-color: ${({ theme }): string => theme.colors.lightGrey};
  padding-left: 34px;
`;

export const SearchIcon = styled(Icons.Search)`
  width: 16px;
  height: 16px;
  position: absolute;
  left: 0;
  top: 9px;
`;
